module.exports = __webpack_public_path__ + "static/media/Products (10) test.74eedc95.png";